import React from 'react'

import Icon from '../../Icon'
import styles from './Timer.module.scss'
import { useTimer } from './hooks/useTimer'

interface TimerProps {
  time: string
  className?: string
  variant?: 'time' | 'big' | 'text'
  icon?: string
}

const Timer = ({ time, className, variant, icon }: TimerProps) => {
  let timeLeft = useTimer(time)

  if (variant === 'text') {
    timeLeft = time
  }

  return (
    <div className={`${styles.timer} ${className}`}>
      {variant === 'big' ? (
        <Icon name='bigTime' className={styles.big} />
      ) : (
        <Icon name={icon || 'time'} className={styles.small} />
      )}
      <p>{timeLeft === 'NaN:NaN:NaN' ? '00:00:00' : timeLeft}</p>
    </div>
  )
}

export default Timer
